import { Jurisdiction } from '@gig/magic-jurisdictions';
import { magic } from '@gig/magic-sdk';
import VueRouter from 'vue-router';
import { RouteName } from '../../../routes/routes.constants';
import { isRouteActive } from '../helpers/routes';
import { getUserJurisdiction } from '../helpers/jurisdiction.helpers';

export function initPlayControlGuard(router: VueRouter) {
    router.beforeEach(async (to, _, next) => {
        const isLotba = (await getUserJurisdiction()) === Jurisdiction.LOTBA;

        if (!isLotba && isRouteActive(RouteName.PLAY_CONTROL, to, router)) {
            return next({
                name: RouteName.HOME,
            });
        }

        next();
    });
}
import {
    USER_SHOW_GAMES_QUERY,
    USER_FETCH_PREFERENCES_COMMAND,
} from '@gig/magic-messages';

//This function is checking for the play control preferences and doing an API call if the store hasn't been updated in the last 10 seconds. Otherwise it reads it for the store.
export function initPCPreferencesGuard(router: VueRouter) {
    router.beforeEach(async (to, _, next) => {
        const isLoggedIn = !!magic.session.getUser();
        const isLotba = (await getUserJurisdiction()) === Jurisdiction.LOTBA;

        if (
            isLotba &&
            isLoggedIn &&
            (isRouteActive(RouteName.GAMES, to, router) ||
                isRouteActive(RouteName.LIVE_CASINO, to, router) ||
                isRouteActive(RouteName.GAMEPLAY, to, router))
        ) {
            await window.commandBus.publish(USER_FETCH_PREFERENCES_COMMAND);
            const showCasinoGames = await window.queryBus.query<boolean>(
                USER_SHOW_GAMES_QUERY,
            );

            if (
                isRouteActive(RouteName.GAMEPLAY, to, router) &&
                !showCasinoGames
            ) {
                return next({
                    name: RouteName.GAMES,
                });
            }
        }

        next();
    });
}
